let language = {
    PREFERENCE_EDITOR_TITLE: "Currency settings",
    PREFERENCE_EDITOR_SUBTITLE1: "{{appName}} website currency",
    PREFERENCE_EDITOR_BODY2: "Click the button below to change the currency for {{appName}} pricing.",
    PREFERENCE_EDITOR_APPLY: "Apply",
    PREFERENCE_EDITOR_RETRY_GET_LIST: "Retry",
    // TODO: Error code

}
export { language }